import { useUser } from '@/hooks/use-user/use-user';

/** Bayonne is served a fixed window, so the range presets are withheld for it. */
export function useIsBayonne(): boolean {
  const { userData } = useUser();

  return userData?.company?.name?.toLowerCase() === 'bayonne';
}
